import { render, staticRenderFns } from "./RisksVE.vue?vue&type=template&id=26a7ce27&"
import script from "./RisksVE.vue?vue&type=script&lang=js&"
export * from "./RisksVE.vue?vue&type=script&lang=js&"
import style0 from "./RisksVE.vue?vue&type=style&index=0&id=26a7ce27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports